import { SPEECH_REPORT_FIELDS_LOADING, SPEECH_REPORT_FIELDS_SUCCESS, SPEECH_REPORT_FIELDS_FAILED } from '../actions/voiceLogs.action';
import { SpeechRecordFieldsListReducer } from '../models/voiceLogs.interface';

const initialState: SpeechRecordFieldsListReducer = {
    speechReportFieldsData: [],
    speechReportFieldsLoading: false,
    speechReportFieldsError: false,
    speechReportFieldsErrorMsg: ''
}

const speechRecordFieldsReducer = (state: SpeechRecordFieldsListReducer = initialState, action: any): SpeechRecordFieldsListReducer => {

    switch (action.type) {
        case SPEECH_REPORT_FIELDS_LOADING:
            return {
                ...state,
                speechReportFieldsLoading: true,
                speechReportFieldsError: false
            }
        case SPEECH_REPORT_FIELDS_SUCCESS:
            return {
                ...state,
                speechReportFieldsLoading: false,
                speechReportFieldsError: false,
                speechReportFieldsData: [...action.payload.res],
            }
        case SPEECH_REPORT_FIELDS_FAILED:
            return {
                ...state,
                speechReportFieldsLoading: false,
                speechReportFieldsError: true,
                speechReportFieldsErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

export default speechRecordFieldsReducer;